import Service from '@ember/service';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import VerifyAndLinkInstrumentRequest from '@square/dashboard-data/models/squareup/simple-instrument-store/external-api/verify-and-link-instrument-request';
import VerifyAndLinkInstrumentResponse from '@square/dashboard-data/models/squareup/simple-instrument-store/external-api/verify-and-link-instrument-response';
import { QueryInstrumentRequest } from '@square/dashboard-data/models/squareup/simple-instrument-store/external-api/query-instrument-request';
import QueryInstrumentResponse from '@square/dashboard-data/models/squareup/simple-instrument-store/external-api/query-instrument-response';
function rpc(requestClass, responseClass) {
  return request => jsonPost(requestClass.url, requestClass.create(request), {
    timeout: 10000
  }).then(response => responseClass.deserialize(response));
}

// eslint-disable-next-line ember/no-classic-classes
export default Service.extend({
  verifyAndLinkInstrument: rpc(VerifyAndLinkInstrumentRequest, VerifyAndLinkInstrumentResponse),
  queryInstrument: rpc(QueryInstrumentRequest, QueryInstrumentResponse)
});